/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

const RATVIEWS_PREFIX = 'RATVIEWS_';

export const FETCH_AGGREGATE_START = `${RATVIEWS_PREFIX}FETCH_AGGREGATE_START`;
export const FETCH_AGGREGATE_SUCCESS = `${RATVIEWS_PREFIX}FETCH_AGGREGATE_SUCCESS`;
export const FETCH_AGGREGATE_FAILURE = `${RATVIEWS_PREFIX}FETCH_AGGREGATE_FAILURE`;

export const FETCH_PUBLIC_REVIEWS_START = `${RATVIEWS_PREFIX}FETCH_PUBLIC_REVIEWS_START`;
export const FETCH_PUBLIC_REVIEWS_SUCCESS = `${RATVIEWS_PREFIX}FETCH_PUBLIC_REVIEWS_SUCCESS`;
export const FETCH_PUBLIC_REVIEWS_FAILURE = `${RATVIEWS_PREFIX}FETCH_PUBLIC_REVIEWS_FAILURE`;
export const PUBLIC_REVIEWS_RESET = `${RATVIEWS_PREFIX}PUBLIC_REVIEWS_RESET`;

export const FETCH_AI_REVIEW_START = `${RATVIEWS_PREFIX}FETCH_AI_REVIEW_START`;
export const FETCH_AI_REVIEW_SUCCESS = `${RATVIEWS_PREFIX}FETCH_AI_REVIEW_SUCCESS`;
export const FETCH_AI_REVIEW_FAILURE = `${RATVIEWS_PREFIX}FETCH_AI_REVIEW_FAILURE`;

export const POST_REVIEW_VOTE_START = `${RATVIEWS_PREFIX}POST_REVIEW_VOTE_START`;
export const POST_REVIEW_VOTE_SUCCESS = `${RATVIEWS_PREFIX}POST_REVIEW_VOTE_SUCCESS`;
export const POST_REVIEW_VOTE_FAILURE = `${RATVIEWS_PREFIX}POST_REVIEW_VOTE_FAILURE`;

export const POST_AI_REVIEW_VOTE_START = `${RATVIEWS_PREFIX}POST_AI_REVIEW_VOTE_START`;
export const POST_AI_REVIEW_VOTE_SUCCESS = `${RATVIEWS_PREFIX}POST_AI_REVIEW_VOTE_SUCCESS`;
export const POST_AI_REVIEW_VOTE_FAILURE = `${RATVIEWS_PREFIX}POST_AI_REVIEW_VOTE_FAILURE`;

export const POST_REVIEW_FLAG_START = `${RATVIEWS_PREFIX}POST_REVIEW_FLAG_START`;
export const POST_REVIEW_FLAG_SUCCESS = `${RATVIEWS_PREFIX}POST_REVIEW_FLAG_SUCCESS`;
export const POST_REVIEW_FLAG_FAILURE = `${RATVIEWS_PREFIX}POST_REVIEW_FLAG_FAILURE`;

export const SET_SELECTED_REVIEW = `${RATVIEWS_PREFIX}SET_SELECTED_REVIEW`;
export const GET_INTERNAL_ACCOUNT_SUCCESSFUL = `${RATVIEWS_PREFIX}GET_INTERNAL_ACCOUNT_SUCCESSFUL`;
export const GET_INTERNAL_ACCOUNT_FAILED = `${RATVIEWS_PREFIX}GET_INTERNAL_ACCOUNT_FAILED`;
export const GET_LOCATION_SUCCESSFUL = `${RATVIEWS_PREFIX}GET_LOCATION_SUCCESSFUL`;
export const GET_LOCATION_FAILED = `${RATVIEWS_PREFIX}GET_LOCATION_FAILED`;
export const GET_EXTERNAL_ACCOUNT_SUCCESSFUL = `${RATVIEWS_PREFIX}GET_EXTERNAL_ACCOUNT_SUCCESSFUL`;
export const GET_EXTERNAL_ACCOUNT_FAILED = `${RATVIEWS_PREFIX}GET_EXTERNAL_ACCOUNT_FAILED`;

export const DENY_REVIEW_SUCCESSFUL = `${RATVIEWS_PREFIX}DENY_REVIEW_SUCCESSFUL`;
export const DENY_REVIEW_FAILURE = `${RATVIEWS_PREFIX}DENY_REVIEW_FAILURE`;
export const APPROVE_REVIEW_SUCCESSFUL = `${RATVIEWS_PREFIX}APPROVE_REVIEW_SUCCESSFUL`;
export const APPROVE_REVIEW_FAILURE = `${RATVIEWS_PREFIX}APPROVE_REVIEW_FAILURE`;

export const FETCH_REVIEW_START = `${RATVIEWS_PREFIX}FETCH_REVIEW_START`;
export const FETCH_REVIEW_SUCCESS = `${RATVIEWS_PREFIX}FETCH_REVIEW_SUCCESS`;
export const FETCH_REVIEW_FAILURE = `${RATVIEWS_PREFIX}FETCH_REVIEW_FAILURE`;

export const PUT_REVIEW_START = `${RATVIEWS_PREFIX}PUT_REVIEW_START`;
export const PUT_REVIEW_SUCCESS = `${RATVIEWS_PREFIX}PUT_REVIEW_SUCCESS`;
export const PUT_REVIEW_FAILURE = `${RATVIEWS_PREFIX}PUT_REVIEW_FAILURE`;

export const FETCH_ORDER_START = `${RATVIEWS_PREFIX}FETCH_ORDER_START`;
export const FETCH_ORDER_SUCCESS = `${RATVIEWS_PREFIX}FETCH_ORDER_SUCCESS`;
export const FETCH_ORDER_FAILURE = `${RATVIEWS_PREFIX}FETCH_ORDER_FAILURE`;
